import { render, staticRenderFns } from "./LocaleBatchImportDialog.vue?vue&type=template&id=5ce14602&scoped=true"
import script from "./LocaleBatchImportDialog.vue?vue&type=script&lang=js"
export * from "./LocaleBatchImportDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce14602",
  null
  
)

export default component.exports